import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const morphLogo = () => {
    const logos = gsap.utils.toArray('.wp-block-rb-snaplogic-logo-container');

    logos.forEach((logo) => {
        const mql = window.matchMedia('(max-width: 1200px)');
        const mobile = mql.matches;
        const letters = logo.querySelectorAll('.letter');
        const mark = logo.querySelector('.mark');
        const mobileRequestDemoButton = document.querySelector(
            '.mobile-request-demo'
        );

        const animation = gsap.timeline({
            scrollTrigger: {
                trigger: logo,
                start: 'top top',
                toggleActions: 'play none none reverse',
                onEnterBack: () => {
                    if (mobile) {
                        mobileRequestDemoButton.classList.remove('active');
                    }
                },
            },
            onComplete: () => {
                if (mobile) {
                    mobileRequestDemoButton.classList.add('active');
                }
            },
        });

        animation.to(
            letters,
            {
                autoAlpha: 0,
                x: -600,
                duration: 0.5,
                stagger: {
                    amount: 0.1,
                    ease: 'power4',
                },
            },
            0
        );

        animation.to(
            mark,
            {
                scale: 1.4,
                y: -10,
            },
            0
        );
    });
};

const numberCounter = () => {
    const counters = gsap.utils.toArray('.wp-block-rb-number-counter span');

    counters.forEach((counter) => {
        const end = counter.getAttribute('data-end');
        const duration = counter.getAttribute('data-duration');
        const interval = counter.getAttribute('data-interval');
        const scrollStart = counter.getAttribute('data-scroll-start');
        gsap.to(counter, {
            innerText: end,
            duration,
            snap: {
                innerText: interval,
            },
            scrollTrigger: {
                trigger: counter,
                start: scrollStart,
            },
        });
    });
};

const snapAnimations = () => {
    let tabs = document.querySelectorAll('.wp-block-rb-solution-tabs__trigger');
    let animations = document.querySelectorAll('.wp-block-rb-solution-tabs__animation-content');
    let mq = window.matchMedia('(max-width: 1024px)');

    animations.forEach( (animation) => {
        const snaps = gsap.utils.toArray('.snap', animation);
        gsap.set(snaps, {
            autoAlpha: 0,
            x: -100
        })

        animation.anim = gsap.timeline({
            paused: true,
        })

        snaps.forEach( (snap) => {
            const ellipse = snap.querySelector(".ellipse");
            animation.anim.to( snap, {
                x: 0,
                autoAlpha: 1,
                duration: 0.4,
                ease: 'power4',
            });
            if(ellipse) {
                gsap.set(ellipse, {
                    autoAlpha: 0,
                    scale: 0,
                });
                animation.anim.to(ellipse, {
                    autoAlpha: 1,
                    duration: 0.2,
                    scale: 1,
                    ease: 'bounce'
                })
            }
        })
    })

    // Animate the snaps when the tab is selected
    tabs.forEach( (tab) => {
        tab.addEventListener('click', (e) => {
            let id = e.target.getAttribute('data-target');
            let animation = document.querySelector(`#${id} .wp-block-rb-solution-tabs__animation-content`);
            animation.anim.play();
        })
    })

    // Animation the first on scroll trigger
    animations.forEach( (animation, index) => {
        if ( (index > 0 && mq.matches) || index === 0  ) {
            ScrollTrigger.create({
                trigger: animation,
                start: 'top 65%',
                onEnter: () => {
                    animation.anim.play();
                }
            })
        }
    })
}

const tabTriggers = () => {
    const tabBlocks = document.querySelectorAll('.wp-block-rb-solution-tabs');
    tabBlocks.forEach((tabBlock) => {

        const tabList = tabBlock.querySelector('.wp-block-rb-solution-tabs__triggers');
        const tabs = tabBlock.querySelectorAll('.wp-block-rb-solution-tabs__trigger');
        const content = tabBlock.querySelectorAll('.wp-block-rb-solution-tabs__wrapper');

        tabs.forEach((tab) => {
            tab.addEventListener('click', (e) => {
                changeTabs(e);
            });
            tab.addEventListener('keypress', (e) => {
                if (e.key === 'Enter') {
                    // changeTabs(e);
                    tab.click();
                }
            });
        });

        let tabFocus = 0;

        tabList.addEventListener('keydown', (e) => {
            // Move right
            if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
                tabs[tabFocus].setAttribute('tabindex', -1);
                if (e.key === 'ArrowRight') {
                    tabFocus++;
                    // If we're at the end, go to the start
                    if (tabFocus >= tabs.length) {
                        tabFocus = 0;
                    }
                    // Move left
                } else if (e.key === 'ArrowLeft') {
                    tabFocus--;
                    // If we're at the start, move to the end
                    if (tabFocus < 0) {
                        tabFocus = tabs.length - 1;
                    }
                }

                tabs[tabFocus].setAttribute('tabindex', 0);
                tabs[tabFocus].focus();
            }
        });
    });
}

const changeTabs = (e) => {
    const target = e.target;
    const parent = target.parentNode;
    const grandparent = parent.parentNode;

    parent
        .querySelectorAll('[aria-selected="true"]')
        .forEach((t) => {
            t.setAttribute('aria-selected', false);
            t.setAttribute('tabindex', -1);
            t.classList.remove('active');
        });

    target.setAttribute('aria-selected', true);
    target.setAttribute('tabindex', 0);
    target.classList.add('active');

    grandparent.querySelectorAll('[role="tabpanel"]').forEach((p) => {
        p.classList.remove('active');
    });

    grandparent.parentNode
        .querySelector(`#${target.getAttribute('aria-controls')}`)
        .classList.add('active');
};

window.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        morphLogo();
        numberCounter();
        snapAnimations();
        tabTriggers();
    }, 0);
});
